/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EntityWithCommentType } from './EntityWithCommentType';
import {
    instanceOfEntityWithCommentType,
    EntityWithCommentTypeFromJSON,
    EntityWithCommentTypeFromJSONTyped,
    EntityWithCommentTypeToJSON,
} from './EntityWithCommentType';

/**
 * @type CreateOrUpdatePtwCommentDtoEntityType
 * 
 * @export
 */
export type CreateOrUpdatePtwCommentDtoEntityType = EntityWithCommentType;


export function CreateOrUpdatePtwCommentDtoEntityTypeFromJSON(json: any): CreateOrUpdatePtwCommentDtoEntityType {
    return CreateOrUpdatePtwCommentDtoEntityTypeFromJSONTyped(json, false);
}

export function CreateOrUpdatePtwCommentDtoEntityTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrUpdatePtwCommentDtoEntityType {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...EntityWithCommentTypeFromJSONTyped(json, true) };
    return  EntityWithCommentTypeFromJSONTyped(json, true);
}

export function CreateOrUpdatePtwCommentDtoEntityTypeToJSON(value?: CreateOrUpdatePtwCommentDtoEntityType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfEntityWithCommentType(value)) {
        return EntityWithCommentTypeToJSON(value as EntityWithCommentType);
    }

    return {};
}

/**
 * Check if a given object implements the CreateOrUpdatePtwCommentDtoEntityType interface.
 */
export function instanceOfCreateOrUpdatePtwCommentDtoEntityType(value: any): value is CreateOrUpdatePtwCommentDtoEntityType {
    if (instanceOfEntityWithCommentType(value)) return true;
    return false;
}

